import React, { useEffect, useRef } from 'react';
import DatePicker from '../class/DatePicker';
import DateConverter from '../class/DateConverter';
import { DatePickerProps } from '../types';
import './style.css';

export const EthiopianDatePicker: React.FC<DatePickerProps> = ({ 
  id = 'default-id-date-picker', 
  placeholder = 'Select a date', 
  onDateChange 
}) => {
  const datePickerRef = useRef<DatePicker | null>(null);

  useEffect(() => {
    datePickerRef.current = new DatePicker(id);
    datePickerRef.current.onDateChange = (formattedDate: string) => {
      onDateChange(formattedDate);
    };

    return () => {
      if (datePickerRef.current) {
        datePickerRef.current.destroy();
      }
    };
  }, [id, onDateChange]);

  return (
    <div>
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        className="padded-input"
        readOnly
      />
    </div>
  );
};

export const convertGregorianToEthiopian = (dateString: string) => {
  const dateConverter = new DateConverter();
  return dateConverter.convertGregorianToEthiopian(dateString);
};
